import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ErrorBoundary } from '@swtorbit/shared-components';
import '@swtorbit/ui/css/games.min.css';
import { configureArtUrl } from '@swtorbit/shared-assets';
import { API_URL } from './config';

// Served game art loads from the games server.
configureArtUrl((path) => `${API_URL}${path}`);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);
